import { render, staticRenderFns } from "./ViewAllChats.vue?vue&type=template&id=7b2a524a&scoped=true"
import script from "./ViewAllChats.vue?vue&type=script&lang=js"
export * from "./ViewAllChats.vue?vue&type=script&lang=js"
import style0 from "./ViewAllChats.vue?vue&type=style&index=0&id=7b2a524a&prod&lang=scss&scoped=true"
import style1 from "./ViewAllChats.vue?vue&type=style&index=1&id=7b2a524a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2a524a",
  null
  
)

export default component.exports